<div class="o-flex o-flex--grids align-items-center border-container pt-2 pb-2">
  <div class="o-flex__item u-flex-4/5@tablet u-flex-1/1@mobile u-flex-1/1@small pt-3 pb-3">
    <p class="mb-0 text text-semibold text-left">
      {{getOpis()}}
    </p>
  </div>
</div>
